/* ----------------------------------------------------------------------- 判断自适应 */
var isWeb;
var isTablB;
var isTablS;
var isMobile;    
var warper = $("#warper");

//var searchBox = $('.pop__search'); // 搜索框
var overlayFullpage = $('.overlay');


// document js begin
$(document).ready(function() {
  /* 弹出图片 */
  $('[data-fancybox="images"]').fancybox({
    thumbs : {
        autoStart : false
    }
  });
  $('[data-fancybox="images02"]').fancybox({
    thumbs : {
        autoStart : false
    }
  });

  //video
  var player = new Plyr('#player');

// resize --------------------------------------------------------------------------------
  $(window).resize(function(){

      //判断 桌面，平板，手机
      if( windowW > 1180 ){ //桌面
          isWeb = true;
          isTablB = false;
          isTablS = false;
          isMobile = false;
      }else if( windowW >= 1024 && windowW <= 1180 ){ //平板-大
          isWeb = false;
          isTablB = true;
          isTablS = false;
          isMobile = false;
      }else if( windowW > 668 && windowW < 1024 ){ //平板-小
          isWeb = false;
          isTablB = false;
          isTablS = true;
          isMobile = false;
      }else if( windowW <= 668){ //手机
          isWeb = false;
          isTablB = false;
          isTablS = false;
          isMobile = true;
      }

      var windowW = $(window).height();
      var windowH = $(window).height();

      var headerH = $('.header').height();
      var headerTopH = $('.header__top').height();

      $('.winH').css('height', windowH);
      if ( isWeb == true ) {
        $('.mt').css('margin-top', headerH);
      } else {
        $('.mt').css('margin-top', headerTopH);
      }

      // 下拉头部添加class ----------------------------------------------------------------
      function scrollCss() {
        if ( $( window ).scrollTop() > headerH ) {
          $("#warper").addClass('scroll');
        }
        else {
          $("#warper").addClass('scroll').removeClass('scroll');
        }
        setTimeout( scrollCss, 100 );
      }
      scrollCss();

  });
  $(window).resize();

  //首页 
  var index_banner = new Swiper ('.index_banner', {
    //autoplay : 8000,
    //autoplayDisableOnInteraction : false,
    loop: true,
    pagination : '.index_banner_page',
    paginationClickable :true,
    prevButton: '.index_banner_prev',
    nextButton: '.index_banner_next',
    onInit: function(swiper){ //Swiper2.x的初始化是onFirstInit
      swiperAnimateCache(swiper); //隐藏动画元素 
      swiperAnimate(swiper); //初始化完成开始动画
    }, 
    onSlideChangeEnd: function(swiper){ 
      swiperAnimate(swiper); //每个slide切换结束时也运行当前slide动画
    } 
  });

  
  //导航下拉
  $(".header__top-nav").slide({
    type:"menu",
    titCell:".m",
    targetCell:".sub",
    effect:"slideDown",
    delayTime:300,
    triggerTime:0,
    returnDefault:true,
    defaultPlay:true
  });

  //营销网络
  $(".contact__sales-col").slide({
    titCell:".contact__sales-hd li",
    targetCell:".contact__sales-item"
  });

  
 

// 跳动数字 ---------------------------------------------------------------- 
  if ( $('.jump_nums').length != 0 ) { 

    var options  =  {
      useEasing:  true,
      useGrouping:  true,
      separator:  '',
      decimal:  '.',
      prefix:  '',
      suffix:  ''
    };
    var  demo1  =  new  CountUp("num01",  0,  57000,  0,  5,  options);
    var  demo2  =  new  CountUp("num02",  0,  50,  0,  5,  options);
    var  demo3  =  new  CountUp("num03",  0,  3000,  0,  5,  options);
    
    $('.jump_nums').bind('inview', function (event, visible) {
      if (visible == true) {
        demo1.start();
        demo2.start();
        demo3.start();
      }
    });

  }

  // 生产设备与工艺 ---------------------------------------------------------------- 
    var indexEquipment = new Swiper ('.index__equipment-slide', {
      autoplay : 5000,
      autoplayDisableOnInteraction : false,
      loop: true,
      slidesPerView : 3,
      slidesPerGroup : 3,
      spaceBetween : 20,
      prevButton: '.index__equipment-slide-prev',
      nextButton: '.index__equipment-slide-next',
      breakpoints: {
        668: {
          slidesPerView : 1,
          slidesPerGroup : 1
        },
        968: {
          slidesPerView : 2,
          slidesPerGroup : 2
        },
        1440: {
          slidesPerView : 3,
          slidesPerGroup : 3
        }
      }
  });

  // 产品详情 ---------------------------------------------------------------- 
    var ProContentSlide = new Swiper ('.product__content-slide', {
      autoplay : 5000,
      autoplayDisableOnInteraction : false,
      loop: true,
      effect : 'fade',
      slidesPerView : 1,
      spaceBetween : 0,
      pagination : '.product__content-slide-page',
      prevButton: '.product__content-slide-prev',
      nextButton: '.product__content-slide-next'
  });


});

// document js end



/* ----------------------------------------------------------------------- 手机侧边导航 */

var btnOpenSidebar = $('.m_icon .hamburger');
btnOpenSidebar.click(function (e) {
    if ( btnOpenSidebar.hasClass('is-closed') ) {
        openSidebar();
    } else {
        closeSidebar();
    }
});
function openSidebar() {
    openBgShadow();
    warper.addClass('toggled');
    btnOpenSidebar.removeClass('is-closed');
    btnOpenSidebar.addClass('is-open');
};
function closeSidebar() {
    closeBgShadow();
    warper.removeClass('toggled');
    btnOpenSidebar.addClass('is-closed');
    btnOpenSidebar.removeClass('is-open');
};

 

// 滚动条 隐藏显示 --------------------------------------------------------------------------------

function unScroll() {//禁止滚动条滚动
  var top = $(document).scrollTop();
  $(document).on('scroll.unable',function (e) {
      $(document).scrollTop(top);
  })
}

function removeUnScroll() {
  $(document).unbind("scroll.unable"); //移除禁止滚动条滚动
}


/* --------------------------------------------------- 全屏阴影 */

function openBgShadow() {//打开全屏阴影
    overlayFullpage.stop().fadeIn(500);
    unScroll();
}

function closeBgShadow() {//关闭全屏阴影
    overlayFullpage.stop().fadeOut(500);
    removeUnScroll();
} 
overlayFullpage.click(function () {
    closeBgShadow();

/*     if ( searchBox.hasClass('on') ) {
        searchBox.removeClass('on');
        removeUnScroll();
    } */
   /*
     if ( mobileQr.is(':visible') ) {
        mobileQr.stop().fadeOut(500);
    }*/
 
    if ( warper.hasClass('toggled') ) {
        closeSidebar();
    } 

});

// search --------------------------------------------------------------------------------
/* function searchClick() {
  $('.header__top-search').click(function () {
    searchBox.addClass('on');
    openBgShadow();
  });
  $('.pop__search-close').click(function () {
    searchBox.removeClass('on');
    closeBgShadow();
  });
}
searchClick();
 */

// 留言反馈 --------------------------------------------------------------------------------
if ( $('.message_form_col').length > 0 ) {
  $("#message_form_col").Validform({});
}

